import { watch } from '@vue/composition-api'

// 外部(HallChannel配信など)で終了予定(expireAt)が変わったら、開いている卓の明細を再取得する。
// カードのmeta(合計/終了予定/バッジ)は配信で更新されるが、ドロワー内の
// vendingHistories(セット・延長一覧)は getTable でしか更新されないため、
// 自動延長発火後に卓を開き直すまで延長明細が反映されない問題を防ぐ。
export const watchExpireAtForRefetch = (getExpireAt, getIsVisible, refetch) => watch(
  getExpireAt,
  (newVal, oldVal) => {
    // 呼び出し側が「自動延長発火か手動変更か」を判別できるよう新旧の値を渡す。
    if (getIsVisible() && newVal !== oldVal) refetch(newVal, oldVal)
  },
)

export default watchExpireAtForRefetch
